import React, { useMemo } from "react";
import { EVENT_FILTER_OPTIONS, getEventFilterCategory } from "./eventTypes";

export const ALL_EVENT_FILTERS = EVENT_FILTER_OPTIONS.map((option) => option.value);

export default function EventTypeFilters({ events = [], selected, onChange }) {
    const selectedSet = useMemo(() => new Set(selected), [selected]);
    const counts = useMemo(() => {
        const result = Object.fromEntries(ALL_EVENT_FILTERS.map((key) => [key, 0]));
        events.forEach((event) => {
            result[getEventFilterCategory(event.type)] += 1;
        });
        return result;
    }, [events]);
    const allSelected = selectedSet.size === ALL_EVENT_FILTERS.length;

    const toggle = (value) => {
        const next = new Set(selectedSet);
        if (next.has(value)) next.delete(value);
        else next.add(value);
        onChange(ALL_EVENT_FILTERS.filter((key) => next.has(key)));
    };

    return (
        <section className="rounded-2xl border border-slate-200/70 bg-white p-4 shadow-sm" aria-label="Фильтры событий" data-testid="event-type-filters">
            <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
                <div>
                    <h2 className="text-sm font-bold text-slate-900">Показывать в календаре</h2>
                    <p className="mt-0.5 text-xs text-slate-500">Можно выбрать несколько категорий одновременно</p>
                </div>
                <div className="flex flex-wrap gap-2" role="group" aria-label="Категории событий">
                    <button
                        type="button"
                        aria-pressed={allSelected}
                        onClick={() => onChange([...ALL_EVENT_FILTERS])}
                        className={`rounded-xl border px-3 py-2 text-sm font-semibold transition-colors ${allSelected ? "border-slate-900 bg-slate-900 text-white" : "border-slate-200 bg-white text-slate-600 hover:bg-slate-50"}`}
                        data-testid="event-filter-all"
                    >
                        Все <span className={`ml-1 rounded-full px-1.5 py-0.5 text-xs ${allSelected ? "bg-white/20" : "bg-slate-100"}`}>{events.length}</span>
                    </button>
                    {EVENT_FILTER_OPTIONS.map((option) => {
                        const active = selectedSet.has(option.value);
                        return (
                            <button
                                key={option.value}
                                type="button"
                                aria-pressed={active}
                                onClick={() => toggle(option.value)}
                                className={`rounded-xl border px-3 py-2 text-sm font-semibold transition-colors ${active ? "border-[#cda834] bg-[#cda834]/10 text-slate-900" : "border-slate-200 bg-white text-slate-500 hover:bg-slate-50"}`}
                                data-testid={`event-filter-${option.value}`}
                            >
                                <span aria-hidden="true">{option.icon}</span> {option.label}
                                <span className={`ml-1 rounded-full px-1.5 py-0.5 text-xs ${active ? "bg-[#cda834]/20" : "bg-slate-100"}`}>{counts[option.value]}</span>
                            </button>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
